import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SitemodelService } from '../../services/sitemodel.service';
import { GammeSite, ModelSite, ListingSite, DetailSite } from '../../models/modelsite';
import { StructureSite } from '../../models/structuresite';
import { User } from '../../models/user';
import { Document } from '../../models/document';
import { Step } from '../../models/steps';
import { Observable } from 'rxjs/Observable';

import { Store } from '@ngrx/store';
import * as fromRoot from '../../common/appstore/index';
import * as layout from '../../common/appstore/actions';

const DEFAULT_LISTING_TYPE = 1;
const DEFAULT_DETAIL_TYPE = 1;

@Component({
  selector: 'step-sitemodel',
  templateUrl: './sitemodel.component.html',
  styleUrls: ['./sitemodel.component.scss']
})
export class SitemodelComponent implements OnInit {

  gammes: GammeSite[] = [];
  currentmodels: ModelSite[] = [];
  currentlistings: ListingSite;
  currentgamme: GammeSite;
  currentdetails: DetailSite;

  structuresite: GammeSite;

  @Input() currentuser: User;
  @Input() currentdocument: Document;
  @Input() stepcontent: any;

  @Output() currentselection = new EventEmitter();

  eventtoemit = { gamme: '', model: '' };

  selected: any = [];

  constructor(
    private servicesitemodel: SitemodelService,
    private store: Store<fromRoot.AppState>
  ) { }

  ngOnInit() {
    this.getStructureSite();
    this.getGamme();

  }

  step = 0;

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  /*getGamme() {
    this.servicesitemodel.getGamme().subscribe( (gammes: GammeSite[]) => {
      this.gammes = gammes;
    });
  }*/

  /*gammeSelected(gamme: GammeSite){
    gamme.selected = !gamme.selected;
    this.selected = gamme;
    this.currentmodels = gamme.models;
    this.step++;
  }*/

  getGamme() {
    if (this.stepcontent) {
      this.gammes = this.stepcontent.etape.rubriques[0].select.widget.choices;
    }
  }

  gammeSelected(event) {
    this.currentgamme = event;
    this.currentmodels = this.stepcontent.etape.rubriques[1].select[event.value];
    this.eventtoemit.gamme = event.value;
  }

  modelselected(event) {
    this.store.dispatch(new layout.ModelSite(event));
    this.eventtoemit.model = event.name;
    this.currentselection.emit(this.eventtoemit);
  }

  gammeselected(event) {
    this.store.dispatch(new layout.GammeSite(event));
  }

  sendStructureSite() {
    this.servicesitemodel.saveStructureSite(this.currentmodels, this.currentuser.id, this.currentdocument.id);
  }

  getStructureSite() {
    this.servicesitemodel.getStructureSite(this.currentuser.id, this.currentdocument.id).subscribe((structuresite: GammeSite) => {
      if (structuresite[0].selected) {
        this.selected = structuresite[0];
        this.currentmodels = structuresite[0].models;
      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/components/sitemodel/sitemodel.component.ts